// src/pages/usa/puertorico/Aguadilla.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: San Sebastián ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function SanSebastian() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>San Sebastián, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover San Sebastián, Puerto Rico</h2>

<p>
  San Sebastián is a charming town located in the northwestern region of Puerto Rico, known for its 
  rich history, beautiful landscapes, and vibrant culture. Nestled in the foothills of 
  the Cordillera Central mountains, this town offers a unique blend of natural beauty and cultural 
  heritage. Visitors can explore its historic architecture, enjoy local cuisine, and participate in 
  traditional festivals that showcase the town's lively spirit.
</p>


      <h3>🚗 Getting There</h3>

<p>
  San Sebastián, also known as <strong>“El Pepino”</strong>, is located in the 
  western mountains of Puerto Rico. The town is surrounded by rivers, forests, 
  and scenic backroads, making the drive part of the adventure. Whether you're 
  coming from San Juan, Aguadilla (BQN), Moca, or Lares, the routes are 
  well‑marked and easy to follow.
</p>

<p>
  <strong>From San Juan:</strong> The drive takes about <strong>2 to 2.5 hours</strong>. 
  Take <strong> PR‑22</strong> west toward Arecibo, then continue on 
  <strong>PR‑2</strong> toward the west coast. Once you reach the Moca area, 
  connect to <strong>PR‑111</strong> east, which leads directly into 
  San Sebastián. This is the most common and smoothest route.
</p>

<p>
  <strong>From Aguadilla (BQN):</strong> This is the closest airport to 
  San Sebastián. The drive takes about <strong>25–35 minutes</strong>. 
  Take <strong>PR‑107</strong> or <strong>PR‑2</strong> toward Moca, then 
  connect to <strong>PR‑111</strong> east. This is the fastest and easiest 
  way to reach the town.
</p>

<p>
  <strong>From Lares:</strong> The drive from Lares takes about 
  <strong> 20–25 minutes</strong>. Follow <strong>PR‑111</strong> west 
  directly into San Sebastián. This route is scenic, with mountain views 
  and winding roads typical of the central region.
</p>

<p>
  No matter which direction you come from, San Sebastián welcomes you with 
  amazing landscapes, rivers, waterfalls, and one of the most vibrant town 
  cultures in western Puerto Rico.
</p>




            <h3>🌟 My Personal Observation</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>Gozalandia Waterfall:</strong> Gozalandia is a stunning waterfall located in San Sebastián.
      It is a popular spot for locals and tourists alike, offering a refreshing swimming hole and 
      beautiful natural surroundings. The waterfall is easily accessible, and the area is well‑maintained, 
      making it a great place to relax and enjoy nature.
      <br />
      <a
        href="https://www.google.com/maps?q=18.360418155553603,-66.98377425416494"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hacienda El Jibarito:</strong> Hacienda El Jibarito is a charming hotel/restaurant in San Sebastián.
      It offers a unique experience with its rustic architecture and traditional Puerto Rican cuisine. Guests can enjoy a 
      peaceful stay while exploring the surrounding mountains, rivers, and waterfalls. The hacienda also hosts cultural events
      and live music, providing an authentic taste of local life. Even if you are not staying at the hacienda, it is worth visiting 
      for a meal, coffee, or snacks, and to enjoy the beautiful views.
      <br />
      <a
        href="https://www.google.com/maps?q=18.3769182409087,-67.02913532507439"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>
</ul>



         <h3>🥾 Other Hidden Gems</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>San Sebastián Mountain Bike Park:</strong>
      <br />
      A popular spot for mountain biking enthusiasts, offering forest trails, 
      downhill routes, and scenic viewpoints. Great for riders looking for 
      adventure in the western mountains.
      <br />
      <a
        href="https://www.google.com/maps?q=18.34729047822539,-66.98898865633872"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Museo Hacienda La Fe:</strong>
      <br />
      A small cultural museum preserving the agricultural and historical 
      heritage of San Sebastián. Visitors can explore artifacts, tools, 
      and exhibits that highlight the town’s rural traditions.
      <br />
      <a
        href="https://www.google.com/maps?q=18.345602404270974,-66.99278042509037"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Festival de la Novilla:</strong>
      <br />
      One of San Sebastián’s most iconic celebrations, held in 
      <strong>January</strong>. The festival features parades, music, 
      artisans, food kiosks, and the traditional “novilla” procession — 
      a lively cultural event that draws visitors from across the island.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Fiestas Patronales de San Sebastián:</strong>
      <br />
      Celebrated in honor of <strong>San Sebastián Mártir</strong>, usually 
      in <strong>January</strong>. The festivities include live music, 
      traditional food, rides, artisans, and cultural activities in the 
      town plaza. It’s one of the most vibrant patron saint festivals 
      in western Puerto Rico.
    </div>
  </li>
</ul>



           <h3>🛏️ Places to Stay in San Sebastián</h3>

<p>
  San Sebastián offers peaceful countryside stays, rustic haciendas, and 
  nature‑focused lodging perfect for travelers exploring waterfalls, rivers, 
  and the western mountains. All of the stays listed below are available on 
  <strong>Expedia</strong> (priority) and <strong>Booking.com</strong>. 
  Always double‑check availability and reviews before booking.
</p>

<ul>

  <li>
    <div className="place-block">
      <strong>Hacienda El Jibarito:</strong>
      A charming countryside hacienda with rustic architecture, a pool, 
      restaurant, gardens, and beautiful mountain views. It offers a peaceful 
      retreat while still being close to Gozalandia and other attractions.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>San Sebastián Bed & Breakfasts (Various Hosts):</strong>
      Several small B&Bs and guesthouses are available throughout the town, 
      offering quiet stays, local hospitality, and easy access to waterfalls 
      and mountain attractions.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Country Cabins & Mountain Lodges:</strong>
      Private cabins and rural lodges around San Sebastián provide privacy, 
      forest views, and a relaxing atmosphere — ideal for couples or families 
      looking to disconnect and enjoy nature.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Eco‑Stays Near Gozalandia:</strong>
      A few eco‑friendly stays and rural homes are located near the famous 
      Gozalandia Waterfall, offering quick access to swimming holes, hiking 
      trails, and scenic viewpoints.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

</ul>




            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here is the video of the Gozalandia Waterfall.
            </p>

            <p>
              <a
                href="https://youtu.be/ivQvpnqCH3A?si=g1oHEBpb5wHGbKrT"
                target="_blank"
                rel="noopener noreferrer"
              >
                Gozalandia (YouTube Video)
              </a>
            </p>


          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/ivQvpnqCH3A?si=g1oHEBpb5wHGbKrT"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/sansebastian/gz3.jpg"
                alt="Gozalandia Waterfall"
              />
            </a>

           
            <img
              src="/images/usa/puertorico/sansebastian/gz2.jpg"
              alt="Gozalandia Waterfall"
            />
            <img
              src="/images/usa/puertorico/sansebastian/gz1.jpg"
              alt="Gozalandia Waterfall"
            />
            <img
              src="/images/usa/puertorico/sansebastian/gz4.jpg"
              alt="Gozalandia Waterfall"
            />
            <img
              src="/images/usa/puertorico/sansebastian/gz5.jpg"
              alt="Gozalandia Waterfall"
            />
             <img
              src="/images/usa/puertorico/sansebastian/brd.jpg"
              alt="Bridge"
            />
             <img
              src="/images/usa/puertorico/sansebastian/hj1.jpg"
              alt="Hacienda El Jibarito"
            />
             <img
              src="/images/usa/puertorico/sansebastian/hj2.jpg"
              alt="Monte Guilarte"
            />
             <img
              src="/images/usa/puertorico/sansebastian/hj3.jpg"
              alt="Plaza Principal"
            />
             <img
              src="/images/usa/puertorico/sansebastian/hj4.jpg"
              alt="Plaza Principal"
            />
             <img
              src="/images/usa/puertorico/sansebastian/hj8.jpg"
              alt="Plaza Principal"
            />
            <img
              src="/images/usa/puertorico/sansebastian/hj5.jpg"
              alt="River"
            />
            <img
              src="/images/usa/puertorico/sansebastian/hj6.jpg"
              alt="Sign"
            />
           


          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
